export default "__VITE_ASSET__CS35MUpp__"